import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/ProjectInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/projects`;
	}
	updateAssociations(e, t, r) {
		return this.api.post(this.buildPath(`${n.baseUrl}/resources/${e}/projectids?resourceType=${t}`), r);
	}
};
export { n as ProjectInternalResource };

//# sourceMappingURL=ProjectInternalResource.js.map